import { Logger } from '@main/utils/logger';
import { BusIframe } from '@main/bus-layer/bus-iframe';
import type { BusEvent } from '@main/utils/bus-event-promisifier';
import { BusEventsPromisifier } from '@main/utils/bus-event-promisifier';
import type { StoreAgentListEventPublisher } from './store-agentlist.usecase';

export class StoreAgentListPublisher implements StoreAgentListEventPublisher {
  private logger: Logger;

  constructor() {
    this.logger = new Logger();
  }

  async publish(nextToken: string, fetchStatus: boolean): Promise<void> {
    const iframe = await BusIframe.getIframe();
    if (!fetchStatus) {
      const payload = {
        pageRequest: {
          nextToken,
          limit: 100,
        },
      };
      const event: BusEvent = {
        type: 'API.LOOKUP_TEAMMATES',
        payload,
      };
      this.logger.info('API.LOOKUP_TEAMMATES:', {
        action: 'API.LOOKUP_TEAMMATES',
        payload,
      });
      return BusEventsPromisifier.promisifySyncEvent({
        event,
        fulfilled: 'API.LOOKUP_TEAMMATES_FULFILLED',
        target: iframe,
      });
    } else {
      const event: BusEvent = {
        type: 'API.FETCH_AVAILABILITIES',
      };
      this.logger.info('API.FETCH_AVAILABILITIES:', {
        action: 'API.FETCH_AVAILABILITIES',
      });
      return BusEventsPromisifier.promisifySyncEvent({
        event,
        fulfilled: 'API.FETCH_AVAILABILITIES_FULFILLED',
        target: iframe,
      });
    }
  }
}
